import { useState, useEffect } from 'react'
import { Button, Input } from 'components'
import Flex from 'components/priority/Flex/Flex'
import { NestedObjectWrapper } from './'
import { useRecoilValue } from 'recoil'
import { caseValuesAtom } from 'atoms'
import { useTranslation } from 'react-i18next'
import { familyTypeKey, formatFamilyType } from '@messenger/utils'

export const NestedObjectWrapperWithKeyMapping = ({
  formField,
  width,
  margin,
}) => {
  const { t } = useTranslation()
  const fieldValue = useRecoilValue(caseValuesAtom(formField.key))
  const [newType, setNewType] = useState(null)
  const [fieldValueKeys, setFieldValueKeys] = useState([])
  const isAdditionalFamily = fieldValue.id === 'additional_family'

  useEffect(() => {
    // Dedupe types case-insensitively — the DB is standardized to lowercase,
    // but unsaved in-memory rows may still carry legacy casing.
    const seenTypes = new Map()
    for (const item of fieldValue?.value ?? []) {
      const key = familyTypeKey(item.type)
      if (!seenTypes.has(key)) seenTypes.set(key, item.type)
    }
    setFieldValueKeys([...seenTypes.values()])
  }, [fieldValue])

  const addNewType = () => {
    if (isAdditionalFamily && !newType) return
    const updatedTypes = fieldValueKeys ? [...fieldValueKeys] : []
    updatedTypes.push(newType)
    setFieldValueKeys(updatedTypes)
    setNewType(null)
  }
  return (
    <Flex width={width} wrap="wrap" margin={margin || '0'}>
      {fieldValueKeys.length > 0 &&
        fieldValueKeys.map((type, index) => (
          <NestedObjectWrapper
            key={`${type}_${index}`}
            type={formField.key}
            shortType={type}
            title={t(`caseFormSectionsLabels.${type}`, {
              defaultValue: formatFamilyType(type),
            })}
            formField={formField}
            width={width}
          />
        ))}
      <Flex
        margin="0 0 24px 0"
        justify="space-between"
        align="flex-end"
        width={width}
      >
        <Input
          label={t(`caseFormSectionsLabels.${formField.addLabel}`)}
          placeholder={t(`caseFormSectionsLabels.${formField.addPlaceholder}`)}
          value={[newType, setNewType]}
          margin="0 12px 0 0"
        />
        <Button onClick={() => addNewType()}>
          {t('nestedObjectWrapperWithKeyMapping.add')}
        </Button>
      </Flex>
    </Flex>
  )
}

export default NestedObjectWrapperWithKeyMapping
